import * as Yup from "yup";
import { joiEmailSchema } from "../../../utils/utils";

export const validationSchema = Yup.object({
  firstName: Yup.string()
    .matches(/^[A-Za-z]+$/, "First name must contain only alphabets")
    .min(1, "Min 1 characters required")
    .max(50, "Max 50 characters allowed")
    .required("First Name is required"),

  lastName: Yup.string()
    .matches(/^[A-Za-z]+$/, "Last name must contain only alphabets")
    .min(1, "Min 1 characters required")
    .max(50, "Max 50 characters allowed")
    .required("Last Name is required"),

  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required")
    .test("joi-email-check", "Invalid email format", function (value) {
      if (!value) return false;
      const { error } = joiEmailSchema.validate(value);
      return !error;
    }),

  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
    .required("Phone number is required"),

  bookingDate: Yup.date()
    .nullable()
    .required("Booking Date is required"),

  bookingTime: Yup.date()
    .nullable()
    .required("Booking Time is required"),

  preference: Yup.string()
    .required("Preference is required"),

  message: Yup.string()
    .max(200, "Max 200 characters allowed")
    .nullable(),
});
